<body class="ltr  leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class=" d-flex align-items-center pl-3">
                                                <!-- <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                    class="mh-45px pb-2"> -->
                                                <div >
                                                    <h3 class="main-content-label mb-1"><b>
                                                        Grievance
                                                        </b></h3>
                                                    <!-- <p class="text-muted card-sub-title mb-0">
                                                        complaint-form works!
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2"></div>
                                        <div class="col-md-3" [formGroup]="complaintSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600" text-center>
                                                        Sr No.
                                                    </th>
                                                    <th class="f600" text-center>
                                                        Student Name
                                                    </th>
                                                    <th class="f600" text-center>
                                                        Department
                                                    </th>
                                                    <th class="f600">
                                                        Grievance  Title
                                                    </th>
                                                    <th class="f600">
                                                        Grievance  Date
                                                    </th>
                                                    <th class="f600">
                                                        Status
                                                    </th>
                                                    <th class="f600">
                                                        View
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let complaint of complaintList; let i = index;">
                                                     <td>
                                                        {{ i + 1 }}
                                                        </td>
                                                        <td>
                                                           {{complaint.StuFirstName}} {{complaint.StuMidName}} {{complaint.StuLastName}}
                                                           </td>
                                                        <td>
                                                            {{complaint.DepartmentName}}
                                                           </td>
                                                    <td>
                                                        {{complaint.GrievanceTitle}}
                                                    </td>
                                                    <td>
                                                        <!-- {{complaint.CreatedAt}} -->  
                                                        {{convertUTCToIST(complaint.CreatedAt)}}
                                                    </td>
                                                    <td>
                                                        {{complaint.CdDesc}}
                                                    </td>
                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                        (click)="details(complaint)"> <i class="fa fa-eye eye"></i>
                                                        </a> 
                                                     </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                    [pageSizeOptions]="pageSizeOptions"
                                    (page)="onPageChange($event)"></mat-paginator>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>

